import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Colors } from '@weberus/ui/styles';

const fadeKeyframes = keyframes`
  0%,
  80%,
  100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const dot = css`
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background: ${Colors.yablue400};
  animation: ${fadeKeyframes} 1.4s infinite ease-in-out both;

  &:nth-of-type(2) {
    animation-delay: 0.16s;
  }

  &:nth-of-type(3) {
    animation-delay: 0.32s;
  }

  & + & {
    margin-left: 1rem;
  }
`;

export const StylesDotLoader = {
  dot,
};

export const StyledDotLoader = {
  LoadingContainer,
  Container,
};
